module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "width": "550",
      "title": _vm.modalTitle,
      "loading": _vm.loading
    },
    on: {
      "on-ok": function($event) {
        return _vm.ok('formValidate')
      },
      "on-cancel": function($event) {
        return _vm.cancel()
      }
    },
    model: {
      value: (_vm.agentFormModal),
      callback: function($$v) {
        _vm.agentFormModal = $$v
      },
      expression: "agentFormModal"
    }
  }, [_c('div', {
    staticClass: "container-recharge",
    staticStyle: {
      "height": "450px"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('div', {
    staticClass: "form-header"
  }, [_c('Form', {
    ref: "formValidate",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 130
    }
  }, [_c('Form-item', {
    attrs: {
      "label": _vm.$t('agent.username'),
      "prop": "username"
    }
  }, [_c('label', {
    staticClass: "value-label "
  }, [_vm._v("\n                               " + _vm._s(_vm.formValidate.username) + "\n                            ")])]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": _vm.$t('agent.oldPassword'),
      "prop": "oldPassword"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.formValidate.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "oldPassword", $$v)
      },
      expression: "formValidate.oldPassword"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": _vm.$t('agent.newPassword'),
      "prop": "newPassword"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.formValidate.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "newPassword", $$v)
      },
      expression: "formValidate.newPassword"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": _vm.$t('agent.confirmPassword'),
      "prop": "confirmPassword"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.formValidate.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "confirmPassword", $$v)
      },
      expression: "formValidate.confirmPassword"
    }
  })], 1)], 1)], 1)])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a470f00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/ChangePassword.vue
// module id = 476
// module chunks = 103